import type { HTMLAttributes, ReactNode } from 'react';
import { flexRender, type Row, type RowData, type TableFeatures } from '@tanstack/react-table';
import { row_getVisibleCells } from '@tanstack/react-table/static-functions';
import { Table } from '..';
export interface TrBodyRowProps<TFeatures extends TableFeatures, T extends RowData> extends HTMLAttributes<HTMLTableRowElement> {
  row?: Row<TFeatures, T>;
  skeletonRow?: ReactNode[];
  href?: string;
  prefetch?: boolean;
  onNavigate?: () => void;
}

/*
 * Table body row component
 *
 * @param row - row data
 * @param loading - loading state to show skeleton
 * @param href - href link
 * @param onNavigate - fires on row link click (including cmd/ctrl click to open in new tab)
 */
export function TrBodyRow<TFeatures extends TableFeatures, T extends RowData>({
  row,
  skeletonRow,
  href,
  prefetch,
  onNavigate,
  ...props
}: TrBodyRowProps<TFeatures, T>) {
  // 'use no memo': TanStack keeps this object's reference while table state (sorting, rows) changes.
  'use no memo';

  return <Table.Tr {...props}>
      {skeletonRow && skeletonRow.map((cell, index) => <Table.Td key={index}>{cell}</Table.Td>)}
      {row && row_getVisibleCells(row).map(cell_0 => <Table.Td key={cell_0.id} href={href} prefetch={prefetch} onNavigate={onNavigate}>
            <span className="text-2xs">
              {flexRender(cell_0.column.columnDef.cell, cell_0.getContext())}
            </span>
          </Table.Td>)}
    </Table.Tr>;
}